import { PLANS_CONSTANTS } from "../constants/planConstants";

export const fetchPlanDetailsAction = (stripeProductIds) => ({
  type: PLANS_CONSTANTS.FETCH_PLAN_DETAILS_REQUEST,
  payload: stripeProductIds
});